import { Component, OnInit, Input } from '@angular/core';
import { ReservationStore } from '../../service/reservation-store';
import { RoomTypeRateSummary } from '../../models/room-type-rate-summary';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { StaySummary } from '../../models/stay-summary';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { RoomStaySummary } from '../../models/room-stay-summary';
import { OnyxEvent } from '../../models/event';

@Component({
  selector: 'pioneer-stay-summary',
  templateUrl: './stay-summary.component.html'
})
export class StaySummaryComponent implements OnInit {

  private onyxEvent: OnyxEvent;

  public roomTypeRateSummaryList: Observable<List<RoomTypeRateSummary>>;
  public staySummary: Observable<StaySummary>;

  constructor(private roomStore: ReservationStore) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {
    this.roomTypeRateSummaryList = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
      .map((roomStaySummary: RoomStaySummary) => {
        return roomStaySummary.roomTypeRateSummaryList;
      });

    this.staySummary = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
      .map((roomStaySummary: RoomStaySummary) => {
        return roomStaySummary.staySummary;
      });
  }

  getCommission(revenue: number): number {
    return revenue * this.onyxEvent.commissionRoomPercentage / 100;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/stay-summary/stay-summary.component.ts